import { useSampleContext } from "../contexts";
import SampleCons from "../constants/sample";

// Barchart component
import PieChart from "./charts/PieChart";

const TrendingMatrices = ({ commonMatrices }) => {
  const { getLabel } = useSampleContext();
  const palette = [
    "#1CA3F0",
    "#F08021",
    "#E5E5E5",
    "#3E517A",
    "#333333",
    "#F39D53",
    "#747474",
    "#004AAD",
    "#8ED1F8",
    "#F1B11E",
  ];

  const getData = () => {
    let data = {
      datasets: [
        {
          data: getLocationData(),
          backgroundColor: palette,
        },
      ],
      labels: getDataLabels(),
    };
    return data;
  };

  const getLocationData = () => {
    const data = commonMatrices
      .filter((matrix) => {
        return SampleCons.FOOD_MATRIX.some((item) => item.value === matrix._id);
      })
      .map((matrix) => {
        return matrix.total;
      });

    const otherTally = commonMatrices
      .filter((matrix) => {
        return !SampleCons.FOOD_MATRIX.some(
          (item) => item.value === matrix._id
        );
      })
      .reduce((accumulator, matrix) => accumulator + matrix.total, 0);
    data.push(otherTally);
    return data;
  };

  const getDataLabels = () => {
    const data = commonMatrices
      .filter((matrix) => {
        return SampleCons.FOOD_MATRIX.some((item) => item.value === matrix._id);
      })
      .map((matrix) => getLabel(matrix._id, SampleCons.FOOD_MATRIX));

    data.push("Other");
    return data;
  };

  return (
    <>
      {commonMatrices.length === 0 ? (
        <div
          className='d-flex justify-content-center align-items-center h-100 bg-light'
          style={{ minWidth: "90%" }}
        >
          No data
        </div>
      ) : (
        <div className='d-flex justify-content-center align-items-center h-100'>
          <PieChart data={getData()} />
        </div>
      )}
    </>
  );
};

export default TrendingMatrices;
